import { GET, POST } from "./common/http";
import { BASE_URL } from "./common/const";

export const GetRefMemberProcedureExaminationDetailByID = (params: any) =>
    GET(`${BASE_URL}/api/RefMemberProcedureExamination/GetDetail?` + params, null);

export const GetRefMemberProcedureExaminationList = (params: any) =>
    GET(`${BASE_URL}/api/RefMemberProcedureExamination/GetList?` + params, null);

export const CreateRefMemberProcedureExamination = (data: any) =>
    POST(`${BASE_URL}/api/RefMemberProcedureExamination/Create`, data);

export const UpdateRefMemberProcedureExamination = (data: any) =>
    POST(`${BASE_URL}/api/RefMemberProcedureExamination/Update`, data);

export const DeleteRefMemberProcedureExamination = (data: any) =>
    POST(`${BASE_URL}/api/RefMemberProcedureExamination/Delete`, data);